export default __webpack_public_path__ + "static/media/Panel_4_Stage1.93d4d3d9.svg";